import { useMemo } from "react";
import { MegaMenuItem } from "@/features/navigation/components/MegaMenu/MegaMenuItem";
import { transformToMegaMenu } from "@/features/navigation/utils/transformToMegaMenu";
import { useMenuItems } from "@/features/theme/hooks/useMenuItems";
import { useMediaQuery } from "@/shared/hooks/useMediaQuery";
import { cn } from "@/shared/utils/style.util";

type MegaMenuProps = { hasOpenDrawer?: boolean };

export const MegaMenu = ({ hasOpenDrawer }: MegaMenuProps) => {
  const apiMenuItems = useMenuItems();
  const menuItems = useMemo(() => transformToMegaMenu(apiMenuItems), [apiMenuItems]);

  const isCompact = hasOpenDrawer ?? false;
  const isNarrow = useMediaQuery("(max-width: 1360px)");
  const isIconOnly = isCompact && isNarrow;

  return (
    <nav
      className={cn(
        "sticky top-14 left-0 right-0 z-40 w-full",
        "bg-white dark:bg-gray-800",
        "border-b border-gray-200 dark:border-gray-700",
        "shadow-sm",
        "transition-[padding] duration-300 ease-in-out",
        hasOpenDrawer && "pl-[286px]",
      )}
      aria-label="Mega menu navigation"
    >
      <div className={cn("max-w-[1400px] mx-auto", isCompact ? "px-2" : "px-6")}>
        <div className={cn(
          "flex items-center justify-center py-2 overflow-visible",
          isCompact ? "gap-0.5" : "gap-1",
        )}
        >
          {menuItems.map((item) => (
            <MegaMenuItem
              key={item.id}
              label={item.label}
              icon={item.icon}
              to={item.to}
              submenu={item.submenu}
              featuredContent={item.featuredContent}
              columns={item.columns}
              isCompact={isCompact}
              isIconOnly={isIconOnly}
            />
          ))}
        </div>
      </div>
    </nav>
  );
};
